import { v4 as uuidv4 } from "uuid";
import { DocumentCategoryRef } from "../../models/document-categories";
import { DocumentTypeRef } from "../../models/document-types";
import { DocumentRef } from "../../models/documents";
import { Period, PeriodType } from "../../models/documents/period";
import { saveDocuments } from "../../services/documents";
import { DOCUMENTS_STATUS_TYPES, DOCUMENT_CATEGORIES, DOCUMENT_TYPES } from "../../utils/constants/constants";

const getDefaultDocument = () => {
  return {
    companyAccount: null,
    createdAt: new Date(0, 0, 1),
    createdByUser: null,
    isDeleted: false,
    id: uuidv4(),
    name: "",
    legalEntity: null,
    employee: null,
    employeeGroup: null,
    client: null,
    vendor: null,
    status: DOCUMENTS_STATUS_TYPES.PENDING,
    published: false,
    filesCount: 0,
    files: [],
    clarifications: [],
    documentTransactions: [],
    category: DOCUMENT_CATEGORIES.OTHER as DocumentCategoryRef,
    type: DOCUMENT_TYPES.Other as DocumentTypeRef,
    period: Period.makePeriod(new Date().getFullYear(), PeriodType.Month, new Date().getMonth() + 1),
    documentDate: new Date(),
  } as DocumentRef;
};

export const saveDocs = async () => {
  const docOne = getDefaultDocument();

  const response = await saveDocuments([docOne], null, true);

  return {
    response,
    docOne,
  };
};
